import { BookingTable } from "@/app/Dashboard/Components/BookingTable";
import { BookingStatus } from "@/gql/graphql";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useOfficeRecord } from "@/app/Offices/Hooks/useOfficeRecord";

export function OfficeBookingsScreen() {
  const office = useOfficeRecord();

  return (
    <div className="py-6">
      <RecordScreenCard title="Pending bookings">
        <BookingTable
          id={"office-pending-bookings"}
          supplierId={office.supplier.id}
        />
      </RecordScreenCard>

      <RecordScreenCard title="Departing bookings">
        <BookingTable
          id={"office-departing-bookings"}
          supplierId={office.supplier.id}
          defaultState={{ statuses: [BookingStatus.Confirmed] }}
        />
      </RecordScreenCard>

      <RecordScreenCard title="Arriving bookings">
        <BookingTable
          id={"office-arriving-bookings"}
          supplierId={office.supplier.id}
          defaultState={{ statuses: [BookingStatus.Confirmed] }}
        />
      </RecordScreenCard>
    </div>
  );
}
